import React from 'react';

import formatter from '../../utilities/formatter';

const CompletedJobsItem = ({
    item,
    editItem,
}) => {

    function updateItem({ target: { name, checked } }) {
        const currentData = { ...item };
        currentData[name] = checked;
        editItem(currentData);
    }

    return (
        <tr>
            <td>{item.customerFirstName + ' ' + item.customerLastName}</td>
            <td>{formatter.date(item.jobCompletedDate)}</td>
            <td className="text-center">
                {item.thankYouSent !== null ? formatter.date(item.thankYouSent) :
                    (
                    <label className="custom-control custom-checkbox d-inline-flex mb-0">
                        <input type="checkbox" className="custom-control-input" name="sendThankYou"
                            checked={item.sendThankYou}
                            onChange={(e) => updateItem(e)}
                        />
                        <span className="custom-control-label">&nbsp;</span>
                    </label>
                )}
            </td>
            <td className="text-center">
                {item.satisfactionSent !== null ? formatter.date(item.satisfactionSent) :
                    (
                    <label className="custom-control custom-checkbox d-inline-flex mb-0">
                        <input type="checkbox" className="custom-control-input" name="sendSatisfaction"
                            checked={item.sendSatisfaction}
                            onChange={(e) => updateItem(e)}
                        />
                        <span className="custom-control-label">&nbsp;</span>
                    </label>
                )}
            </td>
        </tr>
    );
}

export default CompletedJobsItem;